// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ikJ1","notes":"Notes_notes__yMxcj"};